import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { ChatRoomInfo } from 'domain/entities/ChatEntity';
import { CounterState } from 'domain/entities/NotifyEntity';
import { PRIVATE_ROUTES } from 'presentation/router/CONSTANTS';

const initialState: CounterState = {
    key: PRIVATE_ROUTES.SUB.CU_012_01,
    value: 0,
    needReload: false,
    reCount: false,
    payloadAction: '',
    connected: false, //check socket connect
    chatRoom: undefined,
};

export const chatCounterSlice = createSlice({
    name: 'chatCounterSlice',
    initialState,
    reducers: {
        setUnreadMessageCount: (state, action: PayloadAction<number>) => {
            if (state.connected) {
                return {
                    ...state,
                    value: action.payload,
                    reCount: false,
                };
            }
        },
        realoadAndCountMessage: (state, action: PayloadAction<any>) => {
            if (state.connected) {
                return {
                    ...state,
                    needReload: true,
                    reCount: true,
                    payloadAction: action.payload?.action,
                    payloadData: action.payload,
                };
            }
        },
        realoadMessage: (state, action: PayloadAction<any>) => {
            if (state.connected) {
                return {
                    ...state,
                    needReload: true,
                    payloadAction: action.payload?.action,
                    payloadData: action.payload,
                };
            }
        },
        completeRealoadMessage: (state) => {
            return {
                ...state,
                needReload: false,
                payloadAction: '',
            };
        },
        reCountMessage: (state) => {
            if (state.connected) {
                state.reCount = true;
            }
        },
        setMessageConnectSocket: (state, action: PayloadAction<boolean>) => {
            return {
                ...state,
                connected: true,
                needReload: action.payload,
                reCount: true,
            };
        },
        setChatRoom: (state, action: PayloadAction<ChatRoomInfo>) => {
            state.chatRoom = action.payload;
        },
        resetMessageCount: () => {
            return initialState;
        },
    },
});

export const {
    setUnreadMessageCount,
    realoadAndCountMessage,
    setChatRoom,
    setMessageConnectSocket,
    realoadMessage,
    reCountMessage,
    resetMessageCount,
    completeRealoadMessage,
} = chatCounterSlice.actions;

export default chatCounterSlice.reducer;
